<script>
import {mapActions, mapGetters} from "vuex";
import {
  getBusinessCardsDoc, getEventAttendeesDoc,
  getQueryBusinessCardsCollection,
  getQueryByCollectionName, getQueryEventAttendeesCollection,
  getQueryEventCollection,
  getQueryEventNotesCollection,
  queryConnectionsCollection,
  queryEventAttendeesCollection,
  queryEventCollection
} from "@/shared/firebase_utils";
import Loading from "@/components/Loading.vue";
import {getCountFromServer, getDocs, limit, query, startAfter, where} from "firebase/firestore";

export default {
  name: "NotesAnalyticsDetails",
  components: {Loading},
  data() {
    return {
      notesData: [],
      currentEventId: null,
      headers: [
        {
          text: "",
          value: "image",
          align: "end",
        },
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        {
          text: "Business Name",
          value: "businessName",
          align: "start",
        },
        {
          text: "Job Title",
          value: "jobTitle",
          align: "start",
        },
        {
          text: "Notes created",
          value: "notesCreated",
          align: "start",
        }
      ],
    }
  },
  computed: {
    ...mapGetters(["currentEvent"]),
    breadCrumbItems() {
      if (this.currentEvent) {
        return [
          {
            text: "EventConnect",
            disabled: false,
            routeName: "MultiConnect",
            params: "",
          },
          {
            text: this.currentEvent.name,
            disabled: false,
            routeName: "editMultiConnect",
            params: {eventId: this.currentEvent.id},
            query: {tab: 5}
          },
          {
            text: 'Analytics',
            disabled: false,
            routeName: "editMultiConnect",
            params: {
              eventId: this.currentEvent.id,
            },
            query: {tab: 5}
          },
          {
            text: 'Notes',
            disabled: true,
            routeName: "notesAnalytics",
            params: {
              eventId: this.currentEvent.id,
            },
          },
        ];

      } else return [];
    },
  },
  methods: {
    ...mapActions(["initializeCurrentEvent"]),
    handleRoute(item) {
      if (!item.disabled) {
        let route = {name: item.routeName, params: item.params};
        if (item.query) {
          route.query = item.query;
        }
        this.$router.push(route);
      }
    },
    async getNotesDataWithUserDetails(userUid, notesCount) {
      let businessCard;
      const attendeeData = await getEventAttendeesDoc(this.currentEventId+'-'+userUid);
      if (attendeeData.exists()) {
        if (attendeeData.data().businessCardId) {

          const getBusinessCard = await getBusinessCardsDoc(attendeeData.data().businessCardId);
          if (getBusinessCard.exists()) {
            businessCard = getBusinessCard.data();
          }
        }
      } else {
        const userBusinessCard = await getQueryBusinessCardsCollection(where("uid", "==", userUid));
        if (userBusinessCard.size) {
          businessCard = userBusinessCard.docs[0].data();
        }
      }
      if (businessCard) {
        return {
          displayImageUrl: businessCard.displayImageUrl,
          name: businessCard.firstName + ' ' + businessCard.lastName,
          businessName: businessCard.businessName,
          jobTitle: businessCard.jobTitle,
          notesCreated: notesCount,
        };
      }

    },
    async getNotesData() {
      let notesData = await getQueryEventNotesCollection(where("eventId", "==", this.currentEventId));
      const notes = Object.groupBy(notesData.docs.map(doc => doc.data()), ({uid}) => uid);
      const notesDetails = await Promise.all(Object.keys(notes).map(uid => this.getNotesDataWithUserDetails(uid, notes[uid].length)));
      this.notesData = notesDetails.filter(note => note !== undefined);
    },
    async saveEvent() {
      await this.initializeCurrentEvent(this.currentEventId);
      await this.getNotesData();
    }
  },
  created() {
    this.currentEventId = this.$route.params.eventId;
    this.saveEvent();
  }

}
</script>
<template>
  <v-container fluid :class="currentEvent == null || !this.notesData ? 'fill-height' : ''">
    <v-row v-if="currentEvent == null || !this.notesData">
      <v-col>
        <Loading/>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-breadcrumbs :items="breadCrumbItems" large>
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
                :disabled="item.disabled"
                :class="[
                'text-capitalize px-0',
                {
                  'cursor-pointer':
                    item.routeName != $route.name && !item.disabled,
                },
              ]"
                @click="handleRoute(item)"
            >
              <div
                  :class="[
                  item.routeName != $route.name && !item.disabled
                    ? 'primary--text'
                    : 'grey--text',
                  'text-subtitle ',
                ]"
              >
                {{ item.text }}
              </div>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-col>
      <v-col cols="12">
        <v-card outlined min-height="110vh" class="px-8 py-4">
          <v-card-title>
            Notes
          </v-card-title>
          <v-col>
            <v-row>

              <div style="background-color: #F6F7FC; border-radius: 6px" class="ma-4">
                <v-row class="ma-auto px-4 py-2" align="center">

                  <img src="@/assets/icons/notepad.svg" height="30" width="35" style="color: black"
                       class="pr-2">{{ this.currentEvent.analyticsData.eventNotes }} notes created
                </v-row>
              </div>

            </v-row>
            <v-data-table
                :headers="headers"
                :items="notesData"
                :items-per-page="-1"
                hide-default-footer
            >
              <template v-slot:[`item.image`]="{ item }">
                <v-avatar size="40">
                  <v-img :src="item.displayImageUrl"/>
                </v-avatar>
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <span>{{ item.name }}</span>
              </template>
              <template v-slot:[`item.businessName`]="{ item }">
                <span>{{ item.businessName }}</span>
              </template>
              <template v-slot:[`item.jobTitle`]="{ item }">
                <span>{{ item.jobTitle }}</span>
              </template>
              <template v-slot:[`item.notesCreated`]="{ item }">
                <span>{{ item.notesCreated }}</span>
              </template>
            </v-data-table>


          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-container>


</template>

<style scoped>

</style>